/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

const XSvg = ({ fill = "#E46D64", width = "20", height = "20" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none" test-id="zvYo22jB">

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4998 11.1526L5.93162 15.8334L4.6665 14.5371L9.23472 9.85631L4.94714 5.46304L6.21225 4.16675L10.4998 8.56001L14.7874 4.16675L16.0525 5.46304L11.765 9.85631L16.3332 14.5371L15.0681 15.8334L10.4998 11.1526Z"
        fill={fill} test-id="R0eohjmU" />

    </svg>);

};

export default XSvg;